module.exports = __webpack_public_path__ + "img/dj.233bb83a.svg";